<template>
    <div class="ah-page bank-transfer-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>存款帳戶互轉</h1>
                    </div>
                    <div class="actions">
                        <el-button
                            v-if="isAuth('E01')"
                            type="dark-transparent"
                            icon="el-icon-back"
                            @click="$router.push({ name: 'variable-statement' })"
                            >回財務收支</el-button
                        >
                        <el-button @click="onAdd" type="highlight" icon="el-icon-plus">新增帳戶互轉</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="query-bar">
            <div class="ah-container">
                
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body">
                    <div class="query-bar">
                        <div class="query-items">
                            <div class="query-item">
                                <span class="query-label">系統單號</span>
                                <el-input
                                    v-model="queryParams.systemNo"
                                    :maxlength="50"
                                    :show-word-limit="false"
                                    size="small"
                                    class="system-no-input"
                                    clearable
                                    @keyup.enter.native="onSearchClick"
                                ></el-input>
                            </div>
                            <div class="query-item">
                                <span class="query-label">查詢互轉日期</span>
                                <el-date-picker
                                    :default-time="['00:00:00', '23:59:59']"
                                    v-model="dateRange"
                                    value-format="timestamp"
                                    type="daterange"
                                    range-separator="～"
                                    start-placeholder="開始日期"
                                    end-placeholder="結束日期"
                                    :clearable="false"
                                    :picker-options="pickerOptions"
                                    class="time-range-picker"
                                    size="small"
                                ></el-date-picker>
                            </div>
                            <div class="query-item">
                                <el-button type="primary" @click="onSearchClick" icon="el-icon-search" size="small">查詢</el-button>
                            </div>
                        </div>
                    </div>

                    <div class="table-section">
                        <el-table
                            v-loading="isLoading"
                            :data="list"
                            :row-class-name="getRowClass"
                            @row-click="onRowClick"
                            class="accounting-summary-table row-click ah-el-data-table"
                            empty-text="沒有資料"
                            style="width: 100%"
                        >
                            <el-table-column prop="systemNo" label="系統單號" width="120">
                                <template slot-scope="scope">
                                    <div class="idx">{{ scope.row.systemNo }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="transferDate" label="互轉日期" width="120">
                                <template slot-scope="scope">
                                    {{ scope.row.transferDate | dateFormater("YYYY-MM-dd") }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="sourceBankName" label="轉出帳戶" width="120">
                                <template slot-scope="scope">
                                    <div style="font-weight: bold;">{{ scope.row.sourceBankName }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sourceAmt" label="轉出金額" width="120">
                                <template slot-scope="scope">
                                    <Money :v="scope.row.sourceAmt" :precision="scope.row.sourceCny === 'TWD' ? null : 4" />
                                    <ahTip v-if="scope.row.sourceCny !== 'TWD'">
                                        約當台幣：
                                        <Money :v="scope.row.sourceAmt * scope.row.sourceRate" round />
                                        <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px">匯率：{{ scope.row.sourceRate }}</div>
                                    </ahTip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sourceFee" label="匯費" width="80">
                                <template slot-scope="scope">
                                    <Money :v="scope.row.sourceFee" :precision="scope.row.sourceCny === 'TWD' ? null : 4" />
                                    <ahTip v-if="scope.row.sourceCny !== 'TWD'">
                                        約當台幣：
                                        <Money :v="scope.row.sourceFee * scope.row.sourceRate" round />
                                        <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px">匯率：{{ scope.row.sourceRate }}</div>
                                    </ahTip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="50">
                                <i class="el-icon-right" />
                            </el-table-column>
                            <el-table-column prop="targetBankName" label="轉入帳戶" width="120">
                                <template slot-scope="scope">
                                    <div style="font-weight: bold;">{{ scope.row.targetBankName }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="轉入金額" width="120">
                                <template slot-scope="scope">
                                    <Money :v="scope.row.targetAmt" :precision="scope.row.targetCny === 'TWD' ? null : 4" />
                                    <ahTip v-if="scope.row.targetCny !== 'TWD'">
                                        約當台幣：
                                        <Money :v="scope.row.targetAmt * scope.row.targetRate" round />
                                        <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px">匯率：{{ scope.row.targetRate }}</div>
                                    </ahTip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="匯費" width="80">
                                <template slot-scope="scope">
                                    <Money :v="scope.row.targetFee" :precision="scope.row.targetCny === 'TWD' ? null : 4" />
                                    <ahTip v-if="scope.row.targetCny !== 'TWD'">
                                        約當台幣：
                                        <Money :v="scope.row.targetFee * scope.row.targetRate" round />
                                        <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px">匯率：{{ scope.row.targetRate }}</div>
                                    </ahTip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="note" label="備註" />
                        </el-table>
                        <center style="margin: 30px 0;">
                            <el-pagination
                                layout="prev, pager, next"
                                :page-size.sync="queryParams.PageSize"
                                :total.sync="totalNum"
                                :current-page.sync="queryParams.PageNum"
                                class="pages"
                                @current-change="updateData"
                            >
                            </el-pagination>
                        </center>
                    </div>
                </div>
            </div>
        </div>
        <BankTransferDetailDialog :visible="bankTransferDetailDialog.visible" :sno="bankTransferDetailDialog.sno" @close="onCloseBankTransferDetailDialog" />
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import BankTransferDetailDialog from '@/components/dashboard/Finance/VariableStatement/BankTransferDetailDialog.vue';
import { datePickerOption } from '@/assets/commonData/options';

export default {
    components: { BankTransferDetailDialog },
    data() {
        return {
            isLoading: false,
            list: [],

            dateRange: [],
            queryParams: {
                systemNo: null,
                StartDate: null,
                EndDate: null,
                PageSize: 25,
                PageNum: 1,
            },
            totalNum: 0,

            bankTransferDetailDialog: {
                visible: false,
                sno: null,
            },
            detailDialogSno: null,
            lastDetailDialogSno: null,
            pickerOptions: datePickerOption,
        };
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            let startDate;
            let endDate;

            if (this.$route.query.startDate && this.$route.query.endDate) {
                startDate = Number(moment(+this.$route.query.startDate).startOf('day').format('x'));
                endDate = Number(moment(+this.$route.query.endDate).endOf('day').format('x'));
            } else {
                startDate = Number(moment().startOf('month').format('x'));
                endDate = Number(moment().endOf('month').format('x'));
            }

            this.dateRange = [startDate, endDate];
            this.updateData(false);
        },
        onAdd() {
            this.$router.push({ name: 'variable-statement-bank-transfer-add', query: { startDate: this.$route.query.startDate, endDate: this.$route.query.endDate } });
        },
        async updateData(replaceRouter = false) {
            const DATE_RANGE_START = _.head(this.dateRange);
            const DATE_RANGE_END = _.last(this.dateRange);

            const START_DATE_TIMESTAMP = Number(DATE_RANGE_START);
            const END_DATE_TIMESTAMP = Number(DATE_RANGE_END);
            this.queryParams.StartDate = moment(START_DATE_TIMESTAMP)
                .startOf('day')
                .format('x');
            this.queryParams.EndDate = moment(END_DATE_TIMESTAMP)
                .endOf('day')
                .format('x');

            if (replaceRouter) {
                this.$router.replace({ query: { startDate: DATE_RANGE_START, endDate: DATE_RANGE_END } });
            }
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: '/AccountTransferRecord/GetRecordList',
                    method: 'GET',
                    params: this.queryParams,
                });

                this.list = resp.data.list;
                this.totalNum = resp.data.totalNum;
            } finally {
                this.isLoading = false;
            }
        },
        onCloseBankTransferDetailDialog() {
            this.bankTransferDetailDialog.visible = false;
            this.bankTransferDetailDialog.sno = null;
            this.lastDetailDialogSno = this.detailDialogSno;
            this.detailDialogSno = null;
        },
        onRowClick({ sno }) {
            this.bankTransferDetailDialog.visible = true;
            this.bankTransferDetailDialog.sno = sno;
            this.lastDetailDialogSno = null;
            this.detailDialogSno = sno;
        },
        getRowClass({ row }) {
            if (row.sno === this.detailDialogSno) {
                return 'curr-detail-dialog-target';
            }
            if (row.sno === this.lastDetailDialogSno) {
                return 'last-detail-dialog-target';
            }
            return '';
        },
        onSearchClick() {
            this.queryParams.PageNum = 1;
            this.updateData(true);
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.bank-transfer-page {
    .query-bar {
        margin-bottom: 30px;

        .query-items {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 25px;
        }

        .query-item {
            display: flex;
            align-items: center;
            gap: 10px;

            .query-label {
                font-size: 10pt;
                color: #444;
                white-space: nowrap;
            }
        }

        .time-range-picker {
            width: 310px !important;
        }

        .system-no-input {
            width: 180px;
        }

        @media screen and (max-width: 768px) {
            .query-items {
                flex-direction: column;
                align-items: flex-start;
                gap: 10px;
                padding: 10px 0;
            }

            .query-item {
                width: 100%;
                flex-direction: column;
                align-items: flex-start;
                gap: 5px;

                .el-date-editor,
                .el-input {
                    width: 100% !important;
                }
            }
            .time-range-picker {
                width: 100% !important;
            }
        }
    }
}
</style>
